"use client";

import { Children } from "@/types/types";
import { usePathname } from "next/navigation";
import {
  Dispatch,
  SetStateAction,
  createContext,
  useEffect,
  useState,
} from "react";
import { useRouter } from "next/navigation";

interface BookMenuContextProps {
  isBookMenuOpen: boolean | undefined;
  toggleBookMenu: () => void;
  openBookMenu: () => void;
  closeBookMenu: () => void;
  eatAndDrinskRestaurantValue: string;
  setEatAndDrinskRestaurantValue: Dispatch<SetStateAction<string>>;
  currentBookMenu: number;
  setCurrentBookMenu: Dispatch<SetStateAction<number>>;
}

const BookMenuContextInit = {
  isBookMenuOpen: false,
  toggleBookMenu: () => {},
  openBookMenu: () => {},
  closeBookMenu: () => {},
  eatAndDrinskRestaurantValue: "",
  setEatAndDrinskRestaurantValue: () => {},
  currentBookMenu: 1,
  setCurrentBookMenu: () => {},
};

interface BookMenuProviderProps {
  children: Children;
}

export const BookMenuContext =
  createContext<BookMenuContextProps>(BookMenuContextInit);

function BookMenuProvider({ children }: BookMenuProviderProps) {
  const router = useRouter();
  const pathname = usePathname();

  const [isBookMenuOpen, setBookMenuOpen] = useState<boolean | undefined>(
    undefined
  );

  const [currentBookMenu, setCurrentBookMenu] = useState<number>(1);

  const [eatAndDrinskRestaurantValue, setEatAndDrinskRestaurantValue] =
    useState<string>("");

  const openBookMenu = () => {
    setBookMenuOpen(true);
  };

  const closeBookMenu = () => {
    setBookMenuOpen(false);
  };

  useEffect(() => {
    setBookMenuOpen(false);
  }, [pathname]);

  useEffect(() => {
    const openMenus = (e: MouseEvent) => {
      e.preventDefault();

      const link = (e.target as HTMLAnchorElement)
        .closest("a")!
        .getAttribute("href")!;

      if (link === "#inquire-room") {
        setCurrentBookMenu(1);
        setBookMenuOpen(true);
      } else if (link === "#inquire-meetings") {
        setCurrentBookMenu(2);
        setBookMenuOpen(true);
      } else if (link === "#inquire-restaurant") {
        setCurrentBookMenu(3);
        setBookMenuOpen(true);
      } else if (
        (e.target as HTMLAnchorElement).closest("a")?.target === "_blank"
      ) {
        window.open(link, "_blank");
      } else {
        router.push(link);
      }
    };

    document.querySelectorAll("a").forEach((anchor) => {
      anchor.addEventListener("click", openMenus);
    });

    return () => {
      document.querySelectorAll("a").forEach((anchor) => {
        anchor.removeEventListener("click", openMenus);
      });
    };
  }, [router]);

  return (
    <BookMenuContext.Provider
      value={{
        isBookMenuOpen,
        toggleBookMenu: () => setBookMenuOpen(!isBookMenuOpen),
        openBookMenu,
        closeBookMenu,
        eatAndDrinskRestaurantValue,
        setEatAndDrinskRestaurantValue,
        currentBookMenu,
        setCurrentBookMenu,
      }}
    >
      {children}
    </BookMenuContext.Provider>
  );
}

export default BookMenuProvider;
